
import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { NotificationPreferences } from "@/types/notifications";
import { DEFAULT_PREFERENCES } from "@/constants/notifications";
import { useAuth } from "@/hooks/useAuth";
import { 
  fetchNotificationPreferences, 
  updateNotificationPreferences 
} from "@/services/notificationService";

export { DEFAULT_PREFERENCES };
export type { NotificationPreferences };

export const useNotificationPreferences = () => {
  const { user } = useAuth();
  const queryClient = useQueryClient();

  const { data, isLoading, error } = useQuery({
    queryKey: ["notification_preferences", user?.id],
    queryFn: async () => {
      if (!user?.id) return null;
      return fetchNotificationPreferences(user.id);
    },
    enabled: !!user?.id,
  });

  const mutation = useMutation({
    mutationFn: async (prefs: Partial<NotificationPreferences>) => {
      if (!user?.id) return;
      await updateNotificationPreferences(user.id, prefs);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["notification_preferences", user?.id] });
    },
  });

  return {
    preferences: data || DEFAULT_PREFERENCES,
    isLoading,
    error,
    updatePreferences: mutation.mutateAsync,
    isUpdating: mutation.isPending,
  };
};
